<div *ngIf="isSkeleton; else realDeal" class="flex items-center flex-col">
  <div
    class="text-white border-gray-100 bg-gray-200 border-[3px] rounded-full flex justify-center items-center animate-pulse"
    [class]="size"></div>
  <span class="block h-3 bg-gray-200 animate-pulse rounded w-8/12 mx-auto mt-2"></span>
  <span class="block h-3 bg-gray-200 animate-pulse rounded w-11/12 mx-auto mt-2"></span>
</div>

<ng-template #realDeal>
  <div class="flex items-center flex-col">
    <div
      class="rounded-full flex justify-center items-center"
      [class]="size"
      [ngClass]="{
        'bg-gradient-to-r from-blue-400 to-blue-500 text-white ': variant === 'filled',
        'border-2 border-dashed border-gray-300 text-gray-400': variant === 'outline-dashed',
      }">
      <ng-content></ng-content>
    </div>
    <ng-content select="[name]"></ng-content>
  </div>
</ng-template>
